import './index.scss'
// import '../../assets/scripts/myNiceScroll'
// import {resizeScroll} from '../../assets/scripts/myNiceScroll'
import '@fancyapps/fancybox/dist/jquery.fancybox.min'
import Swiper from 'swiper/swiper-bundle.min.js'

$(document).ready(function(){
  let swipers = $('.section2 .item-swiper');
  for(let i = 0; i < swipers.length; i++){
    new Swiper($(swipers[i]).find('.mySwiper')[0], {
      watchOverflow: true,
      speed: 800,
      slidesPerView: 1,
      slidesPerGroup : 1,
      spaceBetween: 10,
      breakpoints: { //响应式
        768: {  //当屏幕宽度大于等于768 
          slidesPerView: 2,
          slidesPerGroup : 2,
          spaceBetween: 20
        },
        1024: {  //当屏幕宽度大于等于768 
          slidesPerView: 3,
          slidesPerGroup : 3,
          spaceBetween: 20
        },
        1280: {  //当屏幕宽度大于等于1280
          slidesPerView: 3,
          slidesPerGroup : 3,
          spaceBetween: 40
        }
      },
      navigation: {//按钮
        nextEl: $(swipers[i]).find('.swiper-button-next')[0],
        prevEl: $(swipers[i]).find('.swiper-button-prev')[0],
      },
    });
  }
})
